import { render, staticRenderFns } from "./Reclamos.vue?vue&type=template&id=0e214d37&lang=pug"
import script from "./Reclamos.vue?vue&type=script&lang=js"
export * from "./Reclamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports